import * as React from 'react';

interface PageIntroProps {
  header: string;
  preamble?: string;
}

export function PageIntro({header, preamble}: PageIntroProps) {
  return(
    <div className='page-intro-box'>
      <h2 className='page-intro-header'>{header}</h2>
      <div className='page-intro-preamble' dangerouslySetInnerHTML={{__html: preamble as string}}></div>
    </div>
  );
}